import React, { memo } from "react";
import { Skeleton } from "@/components/ui";

export const FiltersSkeleton = memo(function FilterSidebarSkeleton() {
  return (
    <div className="flex-grow px-2">
      <FilterSkeletonGroupHeader />
      <div className="px-2">
        <FilterSkeletonInput />
        <FilterSkeletonInput />
        <FilterSkeletonInput />
      </div>
    </div>
  );
});

const FilterSkeletonGroupHeader = () => (
  <Skeleton className="mx-2 my-4 h-5 w-30" />
);

const FilterSkeletonInput = () => (
  <div className="mt-5 mb-4">
    <Skeleton className="mb-2 h-5 w-39" />
    <Skeleton className="h-[38px]" />
  </div>
);
